import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [mode, setMode] = useState("default");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 400, damping: 40, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 400, damping: 40, mass: 0.6 });

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);
    document.body.classList.add("has-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (t) setMode(t.dataset.cursor || "hover");
      else if (e.target.closest("a, button, input, textarea, select, label")) setMode("hover");
      else setMode("default");
    };
    const leave = () => setMode("hidden");
    const enter = () => setMode("default");
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    document.documentElement.addEventListener("mouseleave", leave);
    document.documentElement.addEventListener("mouseenter", enter);
    return () => {
      document.body.classList.remove("has-cursor");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
      document.documentElement.removeEventListener("mouseleave", leave);
      document.documentElement.removeEventListener("mouseenter", enter);
    };
  }, [x, y]);

  if (!enabled) return null;

  const size = mode === "view" ? 88 : mode === "hover" ? 56 : 14;
  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[300] flex items-center justify-center rounded-full mix-blend-difference"
      style={{ x: sx, y: sy, translateX: "-50%", translateY: "-50%" }}
      animate={{
        width: size,
        height: size,
        opacity: mode === "hidden" ? 0 : 1,
        backgroundColor: mode === "default" ? "#F5F8F5" : "rgba(245,248,245,0.18)",
        borderColor: "rgba(245,248,245,0.9)",
        borderWidth: mode === "default" ? 0 : 1,
      }}
      transition={{ type: "spring", stiffness: 300, damping: 28 }}
      data-testid="custom-cursor"
    >
      {mode === "view" && <span className="text-[10px] font-semibold uppercase tracking-[0.25em] text-sand">View</span>}
    </motion.div>
  );
}
